import Util from '../util'
import Api from '../api'

const api = new Api()
const util = new Util()

/**
 * /manage/joboffers 以下で利用するメソッド
 */
export default class ManageRecruits {
  constructor () {
  }

  /**
   * manage/recruits/new|edit checkbox連動で要素のトグルをさせる処理
   */
  toggleInputs () {
    const checkboxes = document.querySelectorAll('[name="recruit[recruit_area_ids][]"]')
    const tgts = document.querySelectorAll('[data-togglerecruitcity]')

    const changeStatusCb = (self) => {
      const num = self.value
      const tgt = document.querySelector('[data-togglerecruitcity="' + num + '"]')
      if (tgt) {
        if (self.checked) {
          tgt.classList.add('active')
        } else {
          tgt.classList.remove('active')
        }
      }
    }

    if (checkboxes && tgts) {
      util.setEventsRtSelf('change', checkboxes, changeStatusCb.bind(this))
    }

    // ページ読み込み時に一度全件チェック
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        const tgt = document.querySelector('[data-togglerecruitcity="' + checkboxes[i].value + '"]')
        if (tgt) {
          tgt.classList.add('active')
        }
      }
    }
  }

  /**
   * manage/recruits/new|edit 要素のdisabled属性をトグルをさせる処理
   */
  toggleDisable () {
    if (!document.getElementById('js-recruit-form')) {
      return false
    }
    // disabledする対象の一覧
    const tgtlist = [
      {
        toggle: '#recruit_accept_tel',
        tgts: ['#recruit_tel']
      },
      {
        toggle: '#recruit_accept_webform',
        tgts: ['#recruit_webform_email']
      }
    ]

    const changeStatusCb = (self, tgtlist) => {
      for (let i = 0; i < tgtlist.length; i++) {
        const tgt = document.querySelector(tgtlist[i])

        if (self.checked) {
          if (tgt) {
            // tgt.removeAttribute("disabled");
            tgt.readOnly = false
          }
        } else {
          if (tgt) {
            tgt.value = ''
            tgt.readOnly = true
            // tgt.setAttribute("disabled", "disabled");
          }
        }
      }
    }

    // 初回
    for (let i = 0; i < tgtlist.length; i++) {
      const toggle = document.querySelector(tgtlist[i].toggle)
      const tgts = tgtlist[i].tgts

      toggle.addEventListener('change', () => {
        changeStatusCb(toggle, tgts)
      }, false)

      for (let j = 0; j < tgts.length; j++) {
        const tgt = document.querySelector(tgts[j])

        if (toggle.checked) {
          if (tgt) {
            // tgt.removeAttribute("disabled");
            tgt.readOnly = false
          }
        } else {
          if (tgt) {
            // tgt.setAttribute("disabled", "disabled");
            tgt.readOnly = true
          }
        }
      }
    }
  }

  /**
   * manage/recruits/new|edit 給与のトグル処理＋読み込み時に入力されている内容を判定してactiveを付ける
   */
  toggleSalary () {
    const tabbtns = document.querySelectorAll('[data-salarytab]')
    /**
     タブ切り替え処理
     * @param {string} self クリックされたボタン自身
     */
    const toggleTab = (self) => {
      const num = self.getAttribute('data-salarytab');
      const tgtcontent = document.querySelector('[data-salarytgt="' + num + '"]')

      // activeで無くなった方の内容をクリア
      if (num === 'salaryprice2') {
        document.querySelector('[name="recruit[salary]"]').value = ''
      } else {
        document.querySelector('[name="recruit[salary_min]"]').value = ''
        document.querySelector('[name="recruit[salary_max]"]').value = ''
      }

      if (tgtcontent) {
        util.removeClasses(tabbtns, 'active')
        self.classList.add('active')

        util.removeClasses(document.querySelectorAll('[data-salarytgt]'), 'active')
        tgtcontent.classList.add('active')
      }
    }

    if (tabbtns && tabbtns.length > 0) {
      util.setEventsRtSelf('click', tabbtns, toggleTab)

      // ページ読み込み時のactive判定
      if (document.querySelector('[name="recruit[salary]"]').value) {
        document.querySelector('[data-salarytgt="salaryprice1"]').classList.add('active')
      } else if (document.querySelector('[name="recruit[salary_min]"]').value || document.querySelector('[name="recruit[salary_max]"]').value) {
        document.querySelector('[data-salarytgt="salaryprice2"]').classList.add('active')
      } else {
        document.querySelector('[data-salarytgt="salaryprice1"]').classList.add('active')
      }
    }
  }

  /**
   * manage/recruits/new|edit 雇用形態の「説明会・セミナー」「代理店・フランチャイズ」にチェックしたときのトグル
   */
  toggleSeminar () {
    const tgts = document.querySelectorAll('[name="recruit[hiring_ptn_id]"]')
    const changeStatusCb = (self) => {
      const shows = document.querySelectorAll('.toggle_hiring_ptn')
      if (self.parentNode.innerText === '説明会・セミナー') {
        for (let i = 0; i < shows.length; i++) {
          shows[i].classList.add('hide')
        }
        changeLabel('hiringptn7')
      } else if (self.parentNode.innerText === '代理店・フランチャイズ') {
        for (let i = 0; i < shows.length; i++) {
          shows[i].classList.add('hide')
        }
        changeLabel('hiringptn6')
      } else {
        for (let i = 0; i < shows.length; i++) {
          shows[i].classList.remove('hide')
        }
        changeLabel('original')
      }
    }

    if (tgts) {
      util.setEventsRtSelf('change', tgts, changeStatusCb.bind(this))
    }

    /**
     複数セレクタから指定のclassを削除
     * @param {string} tgtname アクティブにするdata属性の値
     */
    const changeLabel = (tgtname) => {
      const datalabel = 'data-' + tgtname
      const tgtlabels = document.querySelectorAll('[' + datalabel + ']')
      for (let i = 0; i < tgtlabels.length; i++) {
        const name = tgtlabels[i].getAttribute(datalabel)
        tgtlabels[i].innerText = name
      }
    }

    // 初回実行
    const checkedTgt = document.querySelector('[name="recruit[hiring_ptn_id]"]:checked')
    if (checkedTgt && checkedTgt.parentNode.innerText === '説明会・セミナー') {
      const shows = document.querySelectorAll('.toggle_hiring_ptn')
      for (let i = 0; i < shows.length; i++) {
        shows[i].classList.add('hide')
        changeLabel('hiringptn7')
      }
    } else if (checkedTgt && checkedTgt.parentNode.innerText === '代理店・フランチャイズ') {
      const shows = document.querySelectorAll('.toggle_hiring_ptn')
      for (let i = 0; i < shows.length; i++) {
        shows[i].classList.add('hide')
        changeLabel('hiringptn6')
      }
    }
  }

  /**
   * manage/recruits/new|edit submit時に非表示項目のデータを消す
   */
  submitAct () {
    const submitBtn = document.querySelector('.manage_recruit_form')
    if (submitBtn) {

      // 非表示の入力項目をブランクに
      const deleteCustom = () => {
        // 職種
        const checks = document.querySelectorAll('[name="recruit[occupation_ids][]"]')
        if (checks && checks.length) {
          for (let i = 0; i < checks.length; i++) {
            checks[i].checked = false
          }
        }
        // 仕事内容、給与、給与詳細、勤務時間（休憩時間）、休日、その他、応募資格、募集人数
        const deleteAry = [
          '[name="recruit[job_detail]"]',
          '[name="recruit[salary]"]',
          '[name="recruit[salary_min]"]',
          '[name="recruit[salary_max]"]',
          '[name="recruit[allowance]"]',
          '[name="recruit[working_hours]"]',
          '[name="recruit[holiday]"]',
          '[name="recruit[treatment]"]',
          '[name="recruit[qualification]"]',
          '[name="recruit[offer_num]"]'
        ]

        for (let i = 0; i < deleteAry.length; i++) {
          const tgt = document.querySelector(deleteAry[i])
          if (tgt) {
            tgt.value = ''
          }
        }
      }

      submitBtn.addEventListener('submit', () => {
        const checkedTgt = document.querySelector('[name="recruit[hiring_ptn_id]"]:checked')
        if (checkedTgt && (checkedTgt.parentNode.innerText === '説明会・セミナー' || checkedTgt.parentNode.innerText === '代理店・フランチャイズ')) {
          deleteCustom()
        }
      })
    }
  }

  /**
   * manage/recruits/new|edit 画像を削除
   */
  setDeleteImg () {
    const tgtbtn = document.getElementById('delete-recruitimage')
    if (tgtbtn) {
      // 画像とimageのvalueを削除
      const deleteImg = () => {
        const deleteTgts = document.querySelectorAll('[data-deletetgt]')

        for (let i = 0; i < deleteTgts.length; i++) {
          const type = deleteTgts[i].getAttribute('data-deletetgt')
          const self = deleteTgts[i]
          if (type === 'val') {
            self.value = ''
          } else if (type === 'img') {
            self.parentNode.removeChild(self)
          }
        }
      }

      tgtbtn.addEventListener('click', deleteImg, false)
    }
  }

  /**
   * manage/tags/new|edit 画像を削除
   */
  setDeleteTagImg() {
    const tgtbtn = document.getElementById('delete-tagimage')
    if (tgtbtn) {
      // 画像とimageのvalueを削除
      const deleteImg = () => {
        const deleteTgts = document.querySelectorAll('[data-deletetgt]')

        for (let i = 0; i < deleteTgts.length; i++) {
          const type = deleteTgts[i].getAttribute('data-deletetgt')
          const self = deleteTgts[i]
          if (type === 'val') {
            self.value = ''
          } else if (type === 'img') {
            self.parentNode.removeChild(self)
          }
        }
      }

      tgtbtn.addEventListener('click', deleteImg, false)
    }
  }

  /**
   * manage/recruits/new|edit チェックボックス連動でデフォルト値をセット
   */
  setDefaultVal () {
    const tgts = document.querySelectorAll('[data-setdefaultval]')
    const changeStatusCb = (self) => {
      if (!self.checked) {
        return false
      }

      const tgtname = self.getAttribute('data-setdefaultval')
      if (tgtname) {
        const tgt = document.querySelector('[name="' + tgtname + '"]')
        if (!tgt.value) {
          tgt.value = tgt.getAttribute('data-jobofferdefault')
        }
      }
    }
    util.setEventsRtSelf('change', tgts, changeStatusCb.bind(this))
  }

  /**
   * manage/recruits/new|edit ファイルinputのchangeイベントをセット
   */
  setUploadChangeEv () {
    const tgt = document.querySelector('[type="file"][name="recruit[image]"]')
    if (!tgt) {
      return false
    }

    const self = this

    const setFile = (file) => {
      window.uploadLocalFile = file
    }

    const fileGet = function (){
      if (this.files.length > 0) {
        // 選択されたファイル情報を取得
        var file = this.files[0];

        // readerのresultプロパティに、データURLとしてエンコードされたファイルデータを格納
        var reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function() {
          setFile(reader.result)
        }
      }
    }

    tgt.addEventListener('change', fileGet, false)
  }

  /**
   * manage/tags/new|edit ファイルinputのchangeイベントをセット
   */
  setTagUploadChangeEv () {
    const tgt = document.querySelector('[type="file"][name="tag[image]"]')
    if (!tgt) {
      return false
    }

    const self = this

    const setFile = (file) => {
      window.uploadLocalFile = file
    }

    const fileGet = function (){
      if (this.files.length > 0) {
        // 選択されたファイル情報を取得
        var file = this.files[0];

        // readerのresultプロパティに、データURLとしてエンコードされたファイルデータを格納
        var reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function() {
          setFile(reader.result)
        }
      }
    }

    tgt.addEventListener('change', fileGet, false)
  }

  /**
   * manage/recruits/new|edit プレビュー表示のセット
   */
  setPrevFrame () {
    const btn = document.getElementById('js-showRecruitPreview')
    if (btn) {
      const closebtn = document.getElementById('js-closeRecruitPreview')
      const tgt = document.getElementById('js-recruitPreview')
      const frame = document.getElementById('js-recruitPreviewFrame')
      const baseHtml = frame.getAttribute('data-previewbaseurl')

      const createParams = () => {
        let params = '?'
        // 雇用形態
        const hiringPtn = document.querySelector('[name="recruit[hiring_ptn_id]"]:checked')
        if (hiringPtn) {
          params += `hiringPtnId=${hiringPtn.value}&`
          params += `hiringPtnName=${hiringPtn.parentNode.innerText}&`
        }
        // 職種
        const occupations = document.querySelectorAll('[name="recruit[occupation_ids][]"]:checked')
        if (occupations) {
          let occupationsAry = []
          for (let i = 0; i < occupations.length; i++) {
            occupationsAry.push(occupations[i].parentNode.innerText)
          }
          params += `occupations=${occupationsAry.join(',')}&`
        }
        // 勤務地
        const recruit_areas = document.querySelectorAll('[name="recruit[recruit_area_ids][]"]:checked')
        if (recruit_areas) {
          let raAry = []
          for (let i = 0; i < recruit_areas.length; i++) {
            const areanum = recruit_areas[i].value
            const cities = document.querySelectorAll('[data-togglerecruitcity="' + areanum + '"] [name="recruit[recruit_city_ids][]"]:checked')
            let arytxt = recruit_areas[i].parentNode.innerText
            for (let j = 0; j < cities.length; j++) {
              arytxt += '|' + cities[j].parentNode.innerText
            }
            raAry.push(arytxt)
          }
          params += `recruit_areas=${raAry.join(',')}&`
        }
        // 更新日
        const today = new Date()
        const month = ('0' + (today.getMonth() + 1)).slice(-2)
        const day = ('0' + today.getDate()).slice(-2)
        params += `updated_at=${today.getFullYear()}年${month}月${day}日&`

        // 電話で問い合わせを受け付けるチェック
        const accept_tel = document.querySelector('[name="recruit[accept_tel]"]').checked
        params += `accept_tel=${accept_tel}&`
        // webフォームで問い合わせを受け付けるチェック
        const accept_webform = document.querySelector('[name="recruit[accept_webform]"]').checked
        params += `accept_webform=${accept_webform}&`

        // その他プレーンな値
        const planeValAry = [
          '[name="recruit[title]"]', // タイトル
          '[name="recruit[point]"]', // アピールポイント
          '[name="recruit[salary_type]"]', // 給与タイプ
          '[name="recruit[salary]"]', // 給与
          '[name="recruit[salary_min]"]', // 給与下限
          '[name="recruit[salary_max]"]', // 給与上限
          '[name="recruit[allowance]"]', // 給与詳細
          '[name="recruit[treatment]"]', // その他
          '[name="recruit[working_hours]"]', // 勤務時間（休憩時間）
          '[name="recruit[holiday]"]', // 休日
          '[name="recruit[qualification]"]', // 応募資格
          '[name="recruit[offer_num]"]', // 募集人数
          '[name="recruit[job_detail]"]', // 仕事内容
          '[name="recruit[contact_detail]"]', // 応募方法詳細
          '[name="recruit[tel]"]', // 受付電話番号
          '[name="recruit[webform_email]"]', // 受付メールアドレス
          '[name="recruit[office_name]"]', // 事業所名
          '[name="recruit[office_zip]"]', // 事務所郵便番号
          '[name="recruit[office_pref]"]', // 件名
          '[name="recruit[office_address]"]', // 住所
          '[name="recruit[office_street]"]', // 住所2
          '[name="recruit[position]"]', // 担当部署名
          '[name="recruit[picname]"]', // 担当者名
          '[name="recruit[website]"]' // Webサイト
        ]

        for (let i = 0; i < planeValAry.length; i++) {
          // タイトル
          const obj = document.querySelector(planeValAry[i])
          const match = planeValAry[i].match(/\[name="recruit\[(.+?)\]"\]/)
          if (obj && match[1]) {
            params += `${match[1]}=${obj.value}&`
          }
        }

        return params
      }

      const setWebflagMsg = () => {
        // 非公開メッセージの表示切り替え
        const webflagmsg = document.querySelector('.webflag-msg')
        const frameControl = document.querySelector('.prevFrame')

        if (document.querySelector('[name="recruit[web_flag]"]:checked').value === 'false') {
          webflagmsg.classList.add('active')
          frameControl.classList.add('webflagfalse')
        } else {
          webflagmsg.classList.remove('active')
          frameControl.classList.remove('webflagfalse')
        }
      }

      const showPrev = () => {
        // frame.setAttribute('src', baseHtml + encodeURI(createParams()))
        frame.setAttribute('src', baseHtml)
        tgt.classList.add('active')
        setWebflagMsg()
      }

      const closePrev = () => {
        frame.removeAttribute('src')
        tgt.classList.remove('active')
        setWebflagMsg()
      }

      btn.addEventListener('click', showPrev, false)
      closebtn.addEventListener('click', closePrev, false)

      // 初期画像のセット
      const nowimg = document.querySelector('.recruit_now_image_area img')
      if (nowimg) {
        window.uploadLocalFile = nowimg.getAttribute('src')
      }
    }
  }
}
